import _ from 'lodash';
import { watch, onBeforeUnmount, WatchStopHandle } from 'vue-demi';

import { useSessionViewsGetters } from './use-session-views-store';
import { useSessionViewsActions } from './use-session-views-actions';
import { useSessions } from '@/modules/sessions-store';

/** TODO: Move to a separate module when more features are added */
export const useApplySessionView = () => {
  const { activeSessionView, activeConversationFilter } = useSessionViewsGetters();
  const { applySessionView } = useSessionViewsActions();
  const { searchAPISessionsInChunks } = useSessions();

  const stop: WatchStopHandle[] = [];
  const subscribeToSessionView = () => {
    /* When agent disables active view in settings use default view */
    const watchIsEnabled = watch(activeSessionView, current => {
      if (!current.isEnabled) {
        applySessionView();
      }
    });

    /* Update "Conversations List" content when settings change */
    const watchActiveFilter = watch(activeConversationFilter, async (current, previous) => {
      if (!_.isEqual(current, previous)) {
        await searchAPISessionsInChunks({ reset: true });
      }
    }, { immediate: true });

    stop.push(watchIsEnabled, watchActiveFilter);
  };

  onBeforeUnmount(() => stop.map(cb => cb()));
  return { subscribeToSessionView };
};
